const skills = [
  {
    icon: 'ri-star-line',
    title: 'Управленческое влияние',
    desc: 'Как руководителю добиваться изменений в поведении сотрудников не только за счёт должностных полномочий, но и через доверие, понятные цели и личный пример.',
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Коммуникация',
    desc: 'Как говорить с сотрудниками так, чтобы задачи, требования и ожидания были поняты правильно, без искажений и необходимости переделывать.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Постановка целей',
    desc: 'Как формировать понятное направление движения команды и связывать индивидуальные задачи с общим результатом бизнеса.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Мотивация',
    desc: 'Как понимать, что действительно влияет на вовлечённость конкретного сотрудника — кроме денег — и создавать условия для высокой самомотивации.',
  },
  {
    icon: 'ri-share-forward-line',
    title: 'Делегирование',
    desc: 'Как передавать ответственность и развивать самостоятельность команды, не теряя контроль над результатом.',
  },
  {
    icon: 'ri-feedback-line',
    title: 'Обратная связь',
    desc: 'Как говорить о результатах и поведении сотрудника так, чтобы разговор приводил к реальным изменениям, а не к обидам или формальному согласию.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Принятие решений',
    desc: 'Как принимать решения в условиях неопределённости, ограниченной информации и брать ответственность за последствия.',
  },
  {
    icon: 'ri-emotion-line',
    title: 'Сложные разговоры',
    desc: 'Как обсуждать ошибки, невыполнение задач, конфликты и другие неприятные темы — не избегая и не усиливая напряжение.',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Развитие сотрудников',
    desc: 'Как видеть потенциал сотрудников, создавать условия для их роста и формировать будущих руководителей внутри компании.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Эмоциональный интеллект',
    desc: 'Как управлять собственным состоянием в стрессовых ситуациях и учитывать эмоциональное состояние команды при принятии решений.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Управление конфликтами',
    desc: 'Как не избегать конфликтов, а переводить их в конструктивное решение — между сотрудниками, подразделениями и руководителями.',
  },
  {
    icon: 'ri-route-line',
    title: 'Управление изменениями',
    desc: 'Как объяснять необходимость изменений, работать с сопротивлением сотрудников и проводить команду через трансформацию.',
  },
];

export default function LeadershipSkills() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Какие лидерские навыки развивает тренинг
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Практические компетенции руководителя, которые помогают влиять на команду и добиваться результата
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {skills.map((skill) => (
            <div key={skill.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${skill.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{skill.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{skill.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}